import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { HeaderState } from '@store/header';

export function useHeaderTitle() {
  const { pathname } = useRouter();

  useEffect(() => {
    if (!pathname) return;

    switch (pathname) {
      case '/':
        HeaderState.title = 'Sound.xyz';
        break;
      case '/feed':
        HeaderState.title = 'Feed';
        break;
      case '/explore':
      case '/search':
        HeaderState.title = 'Search';
        break;
      case '/notifications':
        HeaderState.title = 'Notifications';
        break;
      default:
        HeaderState.title = 'Sound.xyz';
    }
  }, [pathname]);
}
